import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  HRView: false,
  logOutBtn: true,
  isOnlyAttendanceView: false,
};

const isHRViewSlice = createSlice({
  name: "HRView",

  initialState,
  reducers: {
    setHRView: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.HRView = payload;
    },
    resetHRView: (state: any) => {
      state.HRView = false;
    },
    setLogOutBtn: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.logOutBtn = payload;
    },
    resetLogOutBtn: (state: any) => {
      state.logOutBtn = true;
    },
    setIsOnlyAttendanceView: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.isOnlyAttendanceView = payload;
    },
    resetIsOnlyAttendanceView: (state: any) => {
      state.isOnlyAttendanceView = true;
    },
  },
});

export const {
  setHRView,
  resetHRView,
  resetLogOutBtn,
  setLogOutBtn,
  resetIsOnlyAttendanceView,
  setIsOnlyAttendanceView,
} = isHRViewSlice.actions;

export default isHRViewSlice.reducer;
